import { createFileRoute, Link } from "@tanstack/react-router";
import { directoryRegions } from "@/data/directory-pages";
import { regionalServices } from "@/data/regional-services";
import { regionalServiceSlug } from "@/lib/regional-services";
import { breadcrumbLd, jsonLdScript } from "@/lib/json-ld";

export const Route = createFileRoute("/leistungen")({
  staticData: { sitemap: true },
  head: () => ({
    meta: [
      { title: "Reinigung, Rückbau & Entkernung nach Kanton | Begner" },
      {
        name: "description",
        content:
          "Finden Sie Reinigungsfirmen, Hauswartung, Rückbau und Entkernung nach Leistung und Kanton. Firmenprofile, Leistungsumfang und Kostenfaktoren vergleichen.",
      },
    ],
    scripts: [
      jsonLdScript(
        breadcrumbLd([
          { name: "Startseite", path: "/" },
          { name: "Leistungen nach Kanton", path: "/leistungen" },
        ]),
      ),
    ],
  }),
  component: ServicesPage,
});

function ServicesPage() {
  return (
    <>
      <section className="border-b border-border bg-surface py-14 md:py-20">
        <div className="container-page max-w-5xl">
          <p className="text-sm font-semibold text-brand-deep">Firmen nach Leistung und Kanton</p>
          <h1 className="mt-3 font-display text-4xl font-bold md:text-5xl">
            Reinigung, Rückbau und Entkernung in Ihrer Region
          </h1>
          <p className="mt-5 max-w-3xl text-lg leading-8 text-muted-foreground">
            Wählen Sie eine Leistung und anschliessend Ihren Kanton. Auf den regionalen Seiten
            finden Sie veröffentlichte Firmenprofile, Hinweise zur Anfrage und Informationen zu
            Kostenfaktoren.
          </p>
        </div>
      </section>
      <section className="py-12">
        <div className="container-page max-w-5xl space-y-10">
          {(["reinigung", "rueckbau"] as const).map((family) => (
            <div key={family}>
              <h2 className="font-display text-2xl font-bold">
                {family === "reinigung"
                  ? "Reinigung und Hauswartung"
                  : "Rückbau, Demontage und Entkernung"}
              </h2>
              <div className="mt-5 space-y-3">
                {regionalServices
                  .filter((s) => s.family === family)
                  .map((service) => (
                    <details
                      key={service.slug}
                      className="rounded-2xl border border-border bg-card p-5"
                    >
                      <summary className="cursor-pointer py-1 font-display text-xl font-bold">
                        {service.name}
                      </summary>
                      <p className="mt-4 leading-7 text-muted-foreground">{service.intro}</p>
                      <div className="mt-4 grid gap-x-6 gap-y-2 sm:grid-cols-2 lg:grid-cols-3">
                        {directoryRegions.map((region) => (
                          <Link
                            key={region.slug}
                            to="/$serviceRegion"
                            params={{ serviceRegion: regionalServiceSlug(service, region) }}
                            className="inline-flex min-h-11 items-center text-sm font-semibold text-brand-deep hover:underline"
                          >
                            {service.name} {region.name}
                          </Link>
                        ))}
                      </div>
                    </details>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
